angular
  .module('contrast.factory.rule', [])
  .factory('RuleFactory', function ($http, $q, UserService) {
    return {
      getRules: function (params) {
        return $http.get(UserService.buildAPIUrl('/rules'), { params: params })
      },
      getRulesBase: function () {
        return $http.get(UserService.buildAPIUrl('/rules'), {
          params: { base: true }
        })
      },
      getRulesByApplication: function (appId, params) {
        return $http.get(
          UserService.buildAPIUrl('/assess/rules/configs/app/' + appId),
          { params: params }
        )
      },
      getRule: function (name) {
        return $http.get(UserService.buildAPIUrl('/rules/' + name))
      },
      getEnabledRulesForControls: function (language) {
        return $http.get(UserService.buildAPIUrl('/rules/controls/enabled'), {
          params: { lang: language }
        })
      },
      getApplicationsPolicyByRule: function (ruleId, params) {
        return $http.get(
          UserService.buildAPIUrl('/rules/drilldown/' + ruleId),
          { params: params }
        )
      },
      updateStatus: function (name, enabled, environment) {
        return $http.put(
          UserService.buildAPIUrl('/rules/' + name + '/status'),
          { enabled: enabled, environment: environment }
        )
      },
      updateStatusByRule: function (
        appIds,
        name,
        filterText,
        quickFilter,
        devEnv,
        qaEnv,
        prodEnv
      ) {
        return $http.put(
          UserService.buildAPIOrgUrl(
            '/assess/rules/' + name + '/configuration'
          ),
          {
            developmentEnabled: devEnv,
            qaEnabled: qaEnv,
            productionEnabled: prodEnv
          },
          {
            params: {
              appIds,
              quickFilter,
              filterText
            }
          }
        )
      },
      updateStatusByApplication: function (appId, name, enabled, environment) {
        return $http.put(
          UserService.buildAPIUrl(
            '/assess/rules/configs/app/' + appId + '/config'
          ),
          { rule_name: name, enabled: enabled, environment: environment }
        )
      },
      bulkUpdateStatusByApplication: function (
        appId,
        ruleNames,
        devEnabled,
        qaEnabled,
        prodEnabled
      ) {
        return $http.put(
          UserService.buildAPIUrl(
            '/assess/rules/configs/app/' + appId + '/bulk'
          ),
          {
            rule_names: ruleNames,
            dev_enabled: devEnabled,
            qa_enabled: qaEnabled,
            prod_enabled: prodEnabled
          }
        )
      },
      restoreDefaults: function (name) {
        return $http.put(UserService.buildAPIUrl('/rules/' + name + '/restore'))
      },
      customizeRule: function (name, data) {
        return $http.post(UserService.buildAPIUrl('/rules/' + name), data)
      },
      calculateSeverity: function (name, impact, likelihood) {
        return $http.get(
          UserService.buildAPIUrl('/rules/' + name + '/severity'),
          { params: { impact: impact, likelihood: likelihood } }
        )
      },
      getRulesQuickFilters: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl('/rules/filters/quick'),
            params: filters,
            timeout: httpTimeout.promise
          })
        request._httpTimeout = httpTimeout
        return request
      },
      getRuleDrilldownQuickFilters: function (ruleId, filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl(
              '/rules/drilldown/' + ruleId + '/filters/quick'
            ),
            params: filters,
            timeout: httpTimeout.promise
          })
        request._httpTimeout = httpTimeout
        return request
      }
    }
  })
